/**
 * apps/web/src/components/ui/Spinner.tsx
 *
 * Accessible loading spinner. Carries role="status" + an sr-only label so
 * screen readers announce loading state. Tinted with the brand `accent` token
 * so it reads correctly in both themes.
 */

import type React from 'react';
import { Loader2 } from 'lucide-react';
import { cn } from '../../lib/cn';

const SIZE: Record<'sm' | 'md' | 'lg', string> = {
  sm: 'h-4 w-4',
  md: 'h-6 w-6',
  lg: 'h-8 w-8',
};

interface SpinnerProps {
  readonly size?: 'sm' | 'md' | 'lg';
  readonly label?: string;
  readonly className?: string;
}

export function Spinner({ size = 'md', label = 'Caricamento', className }: SpinnerProps): React.ReactElement {
  return (
    // <output> carries an implicit role="status" live region; it was already
    // inline, so no `block` class is needed here.
    <output className={cn('inline-flex items-center', className)}>
      <Loader2 className={cn('animate-spin text-accent', SIZE[size])} aria-hidden="true" />
      <span className="sr-only">{label}</span>
    </output>
  );
}
